import { NgModule, ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProviderSearchComponent } from './providersearch_component/providersearch.component';

import { ProviderComponent } from './provider_component/provider.component';
import { ProviderDetailsComponent } from './providerdetails_component/providerdetails.component';
import { ProviderDashboardComponent } from './../providerportal/providerdashboard/providerdashboard.component';
import { ProviderportalComponent } from './provider-portal/providerportal.component';
import { ClinicalCommunicationsComponent } from './../providerportal/clinical-communications/clinical-communications.component';
import { ClaimsummaryComponent } from './../providerportal/claimsummary/claimsummary.component';
import { ClaimsummarydetailComponent } from './../providerportal/claimsummarydetail/claimsummarydetail.component';
import { EpahafComponent } from './epahaf/epahaf.component';
import { PahafFormComponent } from './epahaf/pahaf-form/pahaf-form.component';
import { EligibilityReportComponent } from './eligibility-report/eligibility-report.component';
import { PcpScorecardComponent } from './pcp-scorecard/pcp-scorecard.component';
import { ProviderTrainingComponent } from './provider-training/provider-training.component';
import { CarePlanDocumentComponent } from '../care-plan-document/care-plan-document.component';
import { PatientSurveyResultComponent } from './patient-survey-result/patient-survey-result.component';
import { ProviderDataUpdateComponent } from '../providerportal/provider-data-update/provider-data-update.component';
import { ProviderOutreachComponent } from './provider-outreach/provider-outreach.component';
import { LoginGuard } from '../guards/login.guard';
import { PqvDashboardComponent } from './pqvdashboard/pqvdashboard.component';
import { PatientDashboardComponent } from './pqvdashboard/patientdashboard/patientdashboard.component';


const ProviderRoutes: Routes = [
  {
    path: '', component: ProviderComponent,
    children: [
      { path: '', redirectTo: '/portal', pathMatch: 'full' },
      { path: 'portal', component: ProviderportalComponent,
        canActivate: [LoginGuard] },
      { path: 'provider-search', component: ProviderSearchComponent },
      { path: 'provider-search/:over-all/:name', component: ProviderSearchComponent },
      { path: 'provider-details', component: ProviderDetailsComponent },
      { path: 'provider-details/:providerId', component: ProviderDetailsComponent },
      { path: 'provider-details/map/:address', component: ProviderDetailsComponent },
      { path: 'provider-details/map/:authId/:authType/:sourceaddress/:destaddress', component: ProviderDetailsComponent },
      { path: 'provider-details/:providerId/:pcpName', component: ProviderDetailsComponent },
      { path: 'provider-dashboard', component: ProviderDashboardComponent },
      { path: 'provider-clinicalCommunications', component: ClinicalCommunicationsComponent },
      {path: 'report', component: EligibilityReportComponent},
      { path: 'pahaf', component: EpahafComponent},
      { path: 'claimsummary', component: ClaimsummaryComponent },
      { path: 'claimsummarydetail/:claimNo', component: ClaimsummarydetailComponent },
      { path: 'pahaf-form', component: PahafFormComponent},
      { path: 'provider-training',component: ProviderTrainingComponent},
      { path: 'care-plan-document',component: CarePlanDocumentComponent},
      { path: 'patient-experience',component: PatientSurveyResultComponent},
      { path: 'provider-dataUpdate', component: ProviderDataUpdateComponent },
      { path: 'provider-outreach', component: ProviderOutreachComponent},
      { path: 'pqv-dashboard', component: PqvDashboardComponent },
      { path: 'patient-dashboard', component: PatientDashboardComponent },
      
        ]
  }

];

@NgModule({
  imports: [
    RouterModule.forChild(ProviderRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class ProviderRouteDefinitions { }
